import { useLayoutEffect, useRef, useState } from 'react'

import { Typography } from '@/components/ui/typography'

import * as S from './block-item-label.styled'

interface BlockItemLabelProps {
  label: string
}

// Truncates to one line and shows the full name in a tooltip on hover, but only when it's
// actually cut off - list labels can come from user-entered data (e.g. a booking type's name)
// with no length limit, while most are short enough to never need the tooltip.
export const BlockItemLabel = ({ label }: BlockItemLabelProps) => {
  const ref = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    const checkTruncation = () => setIsTruncated(element.scrollWidth > element.clientWidth)
    checkTruncation()

    const observer = new ResizeObserver(checkTruncation)
    observer.observe(element)
    return () => observer.disconnect()
  }, [label])

  return (
    <S.LabelTooltip
      fullWidth
      disabled={!isTruncated}
      trigger={
        <S.TruncatedLabel ref={ref}>
          <Typography size="text-small" weight="medium">
            {label}
          </Typography>
        </S.TruncatedLabel>
      }
    >
      {label}
    </S.LabelTooltip>
  )
}
